import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { repositorioFazenda, repositorioFuncionario } from '../../sync/repositories/fazendas';
import { extrairMensagensErro } from '../../utils/errorUtils';

const ESTADO_INICIAL = { nome: '', cpf: '', fazenda: '', cargo: '', custo_hora: '' };

const formatarCpf = (value) => {
  if (!value) return '';
  const cpf = value.replace(/\D/g, '');
  if (cpf.length <= 11) return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return value;
};

/** Modal de cadastro rápido de Funcionário. Busca a lista de fazendas sozinho ao abrir. */
export default function ModalCadastroFuncionario({ isOpen, onClose, onSuccess, fazendaSelecionadaId = null }) {
  const [dados, setDados] = useState(ESTADO_INICIAL);
  const [fazendas, setFazendas] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setDados(ESTADO_INICIAL);
      setErros([]);
      setSalvando(false);
      return;
    }
    repositorioFazenda.listar()
      .then((resp) => setFazendas(Array.isArray(resp.data) ? resp.data : (resp.data.results || [])))
      .catch(() => setFazendas([]));
    setDados((prev) => ({ ...prev, fazenda: fazendaSelecionadaId || '' }));
  }, [isOpen, fazendaSelecionadaId]);

  const handleChange = (campo) => (e) => setDados((prev) => ({ ...prev, [campo]: e.target.value }));

  const handleSalvar = async (e) => {
    e?.preventDefault?.();
    if (!dados.nome.trim()) { setErros(['O nome é obrigatório.']); return; }
    if (dados.cpf.replace(/\D/g, '').length !== 11) { setErros(['Informe um CPF válido (11 dígitos).']); return; }
    if (!dados.fazenda) { setErros(['Selecione a fazenda.']); return; }
    if (!dados.custo_hora) { setErros(['Informe o custo por hora.']); return; }
    setSalvando(true);
    setErros([]);
    try {
      const resp = await repositorioFuncionario.criar({
        nome: dados.nome.trim(),
        cpf: dados.cpf,
        fazenda: dados.fazenda,
        cargo: dados.cargo.trim(),
        custo_hora: Number(dados.custo_hora),
      });
      onSuccess?.(resp.data);
      onClose?.();
    } catch (error) {
      setErros(extrairMensagensErro(error));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={salvando ? () => {} : onClose} title="Cadastrar Funcionário">
      <form onSubmit={handleSalvar} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nome *</label>
          <input
            type="text"
            value={dados.nome}
            onChange={handleChange('nome')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            autoFocus
            disabled={salvando}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">CPF *</label>
            <input
              type="text"
              value={formatarCpf(dados.cpf)}
              onChange={(e) => setDados((prev) => ({ ...prev, cpf: e.target.value.replace(/\D/g, '') }))}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
              maxLength={14}
              disabled={salvando}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Custo/Hora (R$) *</label>
            <input
              type="number" step="0.01" min="0"
              value={dados.custo_hora}
              onChange={handleChange('custo_hora')}
              className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
              disabled={salvando}
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Fazenda *</label>
          <select
            value={dados.fazenda}
            onChange={handleChange('fazenda')}
            disabled={salvando}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300 bg-white"
          >
            <option value="">Selecione...</option>
            {fazendas.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cargo</label>
          <input
            type="text"
            value={dados.cargo}
            onChange={handleChange('cargo')}
            className="w-full border border-gray-300 p-2 rounded focus:ring-2 focus:ring-green-300"
            placeholder="Ex: Tratorista, Administrador..."
            disabled={salvando}
          />
        </div>
        {erros.length > 0 && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-3 space-y-1">
            {erros.map((m, i) => <div key={i}>{m}</div>)}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} disabled={salvando}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 disabled:opacity-50">
            Cancelar
          </button>
          <button type="submit" disabled={salvando}
            className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white disabled:bg-blue-300">
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
